import ApiClient from "../helpers/ApiClient";

const listCategorias = () =>
  ApiClient.apiClientDef.get(`/base/tipos/categorias`);

const listTipos = (params) =>
  ApiClient.apiClientDef.get(`/base/tipos`, {
    params,
  });

const postTipos = (data) => ApiClient.apiClientDef.post(`/base/tipos`, data);

const putTipos = (uid, data) =>
  ApiClient.apiClientDef.put(`/base/tipos/${uid}`, data);

const deleteTipos = (uid) =>
  ApiClient.apiClientDef.delete(`/base/tipos/${uid}`);

const TiposApiClient = {
  listCategorias,
  listTipos,
  postTipos,
  putTipos,
  deleteTipos,
};
export default TiposApiClient;
